<template>
  <div
    :class="[
      'dynamic-condition-item',
      validProps.correct ? 'is-valid' : 'is-not-valid',
      type ? `type-${type}` : ''
    ]"
    :data-qa="'dynamic-condition ' + index ">
    <span class="dynamic-condition-item_title">"{{ title }}"</span>
    <span
      v-if="validProps.errorHint"
      class="dynamic-condition-item_error">
      {{ smallFirstLetter(validProps.errorHint) }}
    </span>
    <b
      v-else-if="containSymbol"
      class="dynamic-condition-item_contain">
      {{ containSymbol }}
    </b>
    <span class="dynamic-condition-item_value">"{{ dynamicCriterion.value }}"</span>
  </div>
</template>
<script>
import { criteriasMixin, modalMixin } from 'mixins'

export default {
  name: 'dynamicCondition',
  mixins: [ criteriasMixin, modalMixin ],
  data() {
    return {
      validProps: {}
    }
  },
  methods: {
    createValidProps() {
      this.validProps = this.checkValidDynamicCondition(this.rows, this.item, this.dynamicCriterion)
    }
  },
  watch: {
    watchKey: {
      immediate: true,
      deep: true,
      handler() {
        this.createValidProps()
      }
    },
  },
  props: {
    item: Object,
    dynamicCriterion: Object,
    index: Number,
    rows: Array,
    type: {
      type: String,
      default: 'hint'
    }
  },
  computed: {
    itemProps() {
      return this.rows?.find(i => i.criteriaMark === this.dynamicCriterion?.targetCriterionMark) || {}
    },
    containSymbol() {
      try {
        let spr = []

        if (this.mixin_contains && this.mixin_contains[this.itemProps?.criterionControlType]) {
          spr = this.mixin_contains[this.itemProps?.criterionControlType]
        } else {
          spr = this.mixin_contains?.default || []
        }

        if (!spr.length) {
          return ''
        }

        const value = spr.find(i => i.value === this.dynamicCriterion?.comparingMode) || {}

        return this.type === 'hint' ? value.text : value.symbol
      } catch (_) {
        return ''
      }
    },
    title() {
      return this.dynamicCriterion.targetCriterionTitle || this.rows.find(crit => crit.criteriaMark == this.dynamicCriterion.targetCriterionMark)?.title || this.dynamicCriterion.targetCriterionMark
    },
    watchKey() {
      return JSON.stringify(this.rows) + this.dynamicCriterion.value + this.dynamicCriterion.comparingMode + this.dynamicCriterion.targetCriterionMark
    }
  }
}
</script>
<style scoped lang="scss">
.dynamic-condition-item {
  $item: &;
  width: 100%;
  text-align: left;
  &.type-hint {
    font-size: 14px;
    line-height: 1.25;
    font-weight: 500;
    padding: 5px 0;
    &:not(:last-child) {
      border-bottom: 1px solid var(--text-color);
    }
    &.is-valid {
      color: var(--text-color);
      caret-color: var(--text-color);
    }
    #{$item}_contain {
      padding: 0 5px;
      text-transform: lowercase;
    }

  }
  &.type-row {
    font-size: 12px;
    line-height: 1.25;
    font-weight: 400;
    &.is-valid {
      color: var(--v-secondary__green_not_active-base);
      caret-color: var(--v-secondary__green_not_active-base);
    }
    #{$item}_title {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 5px;
    }
    #{$item}_value {
      margin-left: 5px;
    }
  }
  &.is-not-valid {
    color: var(--v-secondary__red-base);
    caret-color: var(--v-secondary__red-base);
  }
}
</style>
